import { render, staticRenderFns } from "./PhuProduction.vue?vue&type=template&id=f8d50f6a&scoped=true"
import script from "./PhuProduction.vue?vue&type=script&lang=js"
export * from "./PhuProduction.vue?vue&type=script&lang=js"
import style0 from "./PhuProduction.vue?vue&type=style&index=0&id=f8d50f6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d50f6a",
  null
  
)

export default component.exports